<template>
    <div>
        <div class="body-overlay" id="body-overlay"></div>
        <SearchPopup />
        <Header />
        <div class="banner-area bg-relative pd-bottom-120 banner-small-inner bg-light bg-relative bg-cover text-center">
            <img class="left_image_bounce position-bottom-left" :src="require('@/assets/img/about/4.png')" alt="img">
            <div class="container">
                <h4 class="wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.3s">Nuestros Servicios</h4>
                <h3 class="wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.4s">En Smaco, ofrecemos una amplia gama de servicios de desarrollo de software y soluciones personalizadas para satisfacer las necesidades de tu empresa.</h3>
                <div class="scroll-down top_image_bounce wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.5s">
                    <a href="#service-area">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="80" viewBox="0 0 40 80">
                        <image id="scroll" width="40" height="80" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABQCAYAAABrjzfBAAADwElEQVRoge2bP1LbQBTGP5xQsCoiThD7BIgTxL5BOEGcE0CqlIaSytClg5wA0qUzOQHmBEY3EIW2JfM833oW2bIl78rSJPpmdjwGefent3/13tOeOjjAluoDiAB84mfIIkoAPLM8AXhgWVKq9drWywIKwCmAMwBTq/EpoRLrui5LnzcR8toLgs/lC1AqHwEYArgGcGs3UlACe07YBegmwE6BusViMwAvAHpspCwc+Bu5wQGAGMCE39dqkwXHAD4DOGE3+lSXkPep1t/y6s2zYMgfHwI4rgAOtKjU3Q2UegyUClddlAc4YTcMrYFfhZJU6xNOtruigGNrvOxEqdbSVhwoNc629z7zfcgxd7wrOEuydElXx6nWV+bP9iQxg3aw5SzdSvYyEygVkaGXaj0fWnYXyzr3c5dwWaVaT7nOjsy/jAVrsR5W7CSczTNjRWPBEVf32qxnxK695phcWHBWh/WQsxcHSkmPPqZaH3a4mSdNsJ5RqrWwTAOl+gbwTzPQ3kgW70gAj/LOajVLmOYW7Dapey3JknPUZECZF6HM4leZzXVRrDuwBkq9Fjmw1qoW0FUtoKv+O8CZ5/raLnZWC+iqFtBVLaCrWkBXtYCuagFd9c8BRg5tmeBOKZUFfAQgz9E3JRqL6CCfbXOgLQu4R//1Hhsbbbj+lDcVM9ZS2kGQdaIX0ZTOdok4TXj9xYrfmdBZz8W14jJJpNGBFRmwNbTCXk5+H9dZbCDHVigWtJ4Xj62PZeaZ0YEzfh/6jBb48m6FnKlmZhe23q68W3Yg+8mnv9HnTvKLgPce6/QKaPzcXkO3PgGfM59etM1CnaekCldye9xyVQvoqhbQVR0TcmoaGCPviQH80ACmrOYxxA63pjrSUDZJAOMOg9n9BgIK09RY8KgBQFnN0/g6PIXIo+HHppAxqSJMtX4wy4ykgXytmcuWSZNZpKUskmkqznZb0orEnkWSkWR/GAsmmQefOvVFrMfUlDfJZaGV4FNFQuNGC2ath8xWl9BDcFfHzsKdQ+AuDBxyclivuLPsZNIYCwZKiWEkd/DNMMtLsp3wGaNySAEMlBJvWZRqvbSj5Z1mTiy3WZXdHRKuy7G/pDzAhPtzTPdZacdjAUWs+yXVemAyLrN6t7+/v66q30zwvqElYw/rpNTzHcAPAJep1ufrLi5yYL2l+Xscm2W8q7a63CFmzM/ucUKuVdHnYpO23LUcl2JJ2Y7kNGTefLB9NFLstyWkyJZaardyfV1DipyEzJsP9usaUmTBlxuQz/KvawD4CybGJEiPys7UAAAAAElFTkSuQmCC"/>
                        </svg>
                    </a>
                </div> 
            </div>
        </div>
        <Banner />
        <ServiceArea />
        <ProjectsDone />
        <WorkProcess />
        <Pricing />
        <Testimonial class="bg-sky pd-bottom-240" />
        <Quote />
        <Client />
        <Instagram />
        <Footer />
    </div>
</template>

<script>
    import SearchPopup from '@/components/layout/SearchPopup.vue'
    import Header from '@/components/layout/Header.vue'
    import Banner from '@/components/page/service/Banner.vue'
    import ServiceArea from '@/components/page/service/ServiceArea.vue'
    import Client from '@/components/page/home/Client.vue'
    import Instagram from '@/components/page/home/Instagram.vue'
    import Footer from '@/components/layout/Footer.vue'

    export default {
        name: "Service",
        components: {
            SearchPopup,
            Header,
            Banner,
            ServiceArea,
            Client,
            Instagram,
            Footer
        },
    }
</script>

<style>
.pd-bottom-240 {
    padding-bottom: 240px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Service.vue